// StudioWorkLayer — the assistant's running turns on the Studio canvas, one
// working card each (pen B-04). `anchored`: the ones next to the cards their
// message referenced (on the plane, in canvas units); else the ones with
// nothing to sit beside, in the middle of the view. Pure.

export { StudioWorkLayer };

import type { ReactNode } from "react";
import { StudioWorkingCard } from "../StudioWorkingCard/StudioWorkingCard.js";
import type { StudioWork } from "./studioWork.js";

const StudioWorkLayer = ({
    work,
    anchored,
    onOpenWork,
}: {
    readonly work: readonly StudioWork[];
    readonly anchored: boolean;
    readonly onOpenWork: (conversationId: string) => void;
}): ReactNode => {
    const card = (w: StudioWork) => (
        <StudioWorkingCard
            work={w}
            onOpen={() => onOpenWork(w.conversationId)}
        />
    );
    if (anchored)
        return work.flatMap((w) =>
            w.anchor === null
                ? []
                : [
                      <div
                          key={w.conversationId}
                          className="bilda-studio__slot bilda-studio__work"
                          style={{ left: w.anchor.x, top: w.anchor.y }}
                      >
                          {card(w)}
                      </div>,
                  ],
        );
    const free = work.filter((w) => w.anchor === null);
    return free.length === 0 ? null : (
        <div className="bilda-studio__work-free">
            {free.map((w) => (
                <div key={w.conversationId} className="bilda-studio__work">
                    {card(w)}
                </div>
            ))}
        </div>
    );
};
